<template>
  <div class="home-container">
    <!-- 中部靠下的内容背景层 -->
    <div class="content-background">
      <div class="top-title">AI主題館推廣大使Echo</div>
      <div class="sub-title">帶你遊資訊月</div>
      
      <!-- MTV背景元素 
      <a href="https://www.youtube.com/watch?v=ImVq4YUQtrM" target="_blank" class="mtv-link">
        <div class="mtv-background">
          <img src="@/assets/MTV_按钮.png" class="mtv-button" alt="MTV按钮">
        </div>
      </a>
      -->
      <!--
      <div class="video-container">
        <iframe 
          src="https://www.youtube.com/embed/ImVq4YUQtrM?si=z_x3LkPipVDA7bUZ" 
          frameborder="0" 
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
          allowfullscreen
          class="video-frame">
        </iframe>
      </div>
       -->
      <!-- 产品卡片 -->
      <div class="product-card">
        <div class="guide-icon"></div>
        <div class="product-info">
          <h3 class="product-name">元邦導覽員</h3>
          <p class="product-desc">新一代「領域化身」互動導覽解決方案</p>
          <div class="download-buttons">
            <a href="https://apps.apple.com/tw/app/%E5%85%83%E9%82%A6%E5%B0%8E%E8%A6%BD%E5%93%A1/id6752892219" target="_blank">
              <img src="@/assets/ios_icon.png" class="download-icon" alt="iOS下載">
            </a>
            <a href="https://play.google.com/store/apps/details?id=com.Inventec.IBC.VRStateGuide" target="_blank">
              <img src="@/assets/安卓_icon.png" class="download-icon" alt="Android下載">
            </a>
          </div>
        </div>
      </div>
      <div class="product-card">
        <div class="fashion-icon"></div>
        <div class="product-info">
          <h3 class="product-name">元邦時尚家</h3>
          <p class="product-desc">探索時尚潮流，遇見您的AI造型師</p>
          <div class="download-buttons">
            <a href="https://apps.apple.com/tw/app/%E5%85%83%E9%82%A6%E6%99%82%E5%B0%9A%E5%AE%B6/id6753136548" target="_blank">
              <img src="@/assets/ios_icon.png" class="download-icon" alt="iOS下載">
            </a>
            <a href="https://play.google.com/store/apps/details?id=com.Inventec.IBC.VRStateFashion" target="_blank">
              <img src="@/assets/安卓_icon.png" class="download-icon" alt="Android下載">
            </a>
          </div>
        </div>
      </div>
      <div class="product-card">
        <div class="health-icon"></div>
        <div class="product-info">
          <h3 class="product-name">元邦健管師</h3>
          <p class="product-desc">觸手可及的AI健康管理顧問</p>
          <div class="download-buttons">
            <a href="https://event.vrstate.com/health_ios" target="_blank">
              <img src="@/assets/ios_icon.png" class="cannot-download-icon" alt="iOS下載">
            </a>
            <a href="https://play.google.com/store/apps/details?id=com.Inventec.IBC.VRStateHealth" target="_blank">
              <img src="@/assets/安卓_icon.png" class="download-icon" alt="Android下載">
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HomePage',
  methods: {
    goTo(path) {
      this.$router.push(path)
    },
    redirect() {
      // 修改这里的URL为你想跳转的网页
      window.location.href = 'https://www.example.com'
    }
  }
}
</script>

<style scoped>
.home-container {
  width: 100%;
  min-height: 100vh;
  background-image: url('~@/assets/底1.jpg');
  background-size: cover;
  background-position: top center;
  background-repeat: no-repeat;
  padding: 0;
  margin: 0;
  position: relative;
}

/* 桌面端适配 */
@media (min-width: 768px) {
  .home-container {
    background-size: contain;
  }
}

/* 中部靠下的内容背景 */
.content-background {
  position: absolute;
  top: 30%;
  left: 50%;
  transform: translateX(-50%);
  width: 85%;
  max-width: 500px;
  height: 50%;
  background-image: url('~@/assets/底2.png');
  background-size: 100% 100%;
  background-position: center;
  background-repeat: no-repeat;
  pointer-events: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  padding: 1px 5px;
}

/* 桌面端适配 */
@media (min-width: 768px) {
  .content-background {
    width: 15%;
    max-width: 400px;
  }
}

.top-title {
  color: white;
  font-size: 14px;
  font-weight: bold;
  text-align: center;
  margin-bottom: 1px;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.3);
}

.sub-title {
  color: #adff2f;
  font-size: 16px;
  font-weight: bold;
  text-align: center;
  margin-bottom: 1px;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.3);
}

.mtv-link {
  display: block;
  text-decoration: none;
  width: 90%;
  margin: 0 auto;
}

.mtv-background {
  width: 100%;
  height: auto;
  aspect-ratio: 16 / 9;
  background-image: url('~@/assets/MTV_底图_.jpg');
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  border-radius: 8px;
  margin-bottom: 5px;
  position: relative;
  cursor: pointer;
}

.mtv-button {
  position: absolute;
  bottom: 10px;
  right: 10px;
  width: 80px;
  height: auto;
  cursor: pointer;
  transition: transform 0.3s ease;
}

.mtv-button:hover {
  transform: scale(1.1);
}

.video-container {
  width: 100%;
  background: rgba(0, 0, 0, 0.3);
  border-radius: 8px;
  overflow: hidden;
  margin-bottom: 5px;
}

.video-frame {
  width: 100%;
  height: 150px;
  display: block;
}

.product-card {
  width: 90%;
  background-image: url('~@/assets/底3.png');
  background-size: 100% 100%;
  background-position: center;
  background-repeat: no-repeat;
  border-radius: 12px;
  padding: 8px;
  display: flex;
  align-items: center;
  gap: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  margin-bottom: 3px;
}

.guide-icon {
  width: 40px;
  height: 40px;
  border-radius: 10px;
  flex-shrink: 0;
  background-image: url('~@/assets/logo_导览员.png');
  background-size: cover;
  background-position: center;
}

.fashion-icon {
  width: 40px;
  height: 40px;
  border-radius: 10px;
  flex-shrink: 0;
  background-image: url('~@/assets/logo_时尚家.png');
  background-size: cover;
  background-position: center;
}

.health-icon {
  width: 40px;
  height: 40px;
  border-radius: 10px;
  flex-shrink: 0;
  background-image: url('~@/assets/logo_健管师.png');
  background-size: cover;
  background-position: center;
}

.product-info {
  flex: 1;
  text-align: left;
}

.product-name {
  font-size: 11px;
  font-weight: bold;
  color: #333;
  margin: 0 0 1px 0;
}

.product-desc {
  font-size: 10px;
  color: #666;
  margin: 0 0 4px 0;
  line-height: 1.2;
}

.download-buttons {
  display: flex;
  gap: 8px;
  justify-content: center;
}

.download-buttons a {
  display: inline-block;
  line-height: 0;
}

.download-icon {
  width: 45px;
  height: 15px;
  object-fit: contain;
  cursor: pointer;
  transition: transform 0.3s ease;
}

.cannot-download-icon {
  width: 45px;
  height: 15px;
  object-fit: contain;
  cursor: pointer;
  transition: transform 0.3s ease;
  filter: grayscale(100%);
  opacity: 0.6;
}

.download-icon:hover {
  transform: scale(1.1);
}

/* 手机端适配 */
@media (max-width: 767px) {
  .product-card {
    padding: 8px;
    gap: 5px;
    margin-bottom: 5px;
  }
  
  .guide-icon,
  .fashion-icon,
  .health-icon {
    width: 55px;
    height: 55px;
  }
  
  .product-name {
    font-size: 16px;
    margin: 0 0 2px 0;
  }
  
  .product-desc {
    font-size: 11px;
    margin: 0 0 6px 0;
    line-height: 1.3;
  }
  
  .download-icon {
    width: 90px;
    height: 40px;
  }

  .cannot-download-icon {
    width: 90px;
    height: 40px;
  }

}

</style>
